export default __webpack_public_path__ + "static/media/our-values-HEADER-HD.dd500e00.jpg";